import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { required } from '../../Helpers/validators';
import venuePropType from '../../Constants/venueTypes';
import {
  BY_SEARCH,
  BY_VENUE_CODE,
  BY_MANUAL_ADDRESS,
  venueSearchPropType,
} from '../../Constants/venueSearchTypes';
import VenueSearchTypeRadioField from './VenueSearchTypeRadioField';
import SearchByAddress from './SearchByAddress';
import SearchByVenueCode from './SearchByVenueCode';
import ManualVenueAddress from './ManualVenueAddress';
import { usStatePropType } from '../Insured/StateField';
import { getHasKentuckyFormErrors } from '../../Selectors/venue';
import { Button } from '@jauntin/react-ui';

const Edit = ({
  confirm,
  show,
  validSearchVenue,
  validVenueCode,
  validManualAddress,
  basicCoverageRef,
  scrollToPosition,
  venueInputSelect,
  venueSelectInputOptions,
  venueSearchTypeRadio,
  onSelect,
  address,
  venueState,
  mobile,
  isValidAddress,
  clearForm,
  hasInput,
  isValidState,
  isValidVenueName,
  hasRegionalTax,
  taxRegions,
  isKentuckyEntity,
  venueCodeChecked,
  searchVenueCode,
  usStates,
  facilityCode,
  venueCode,
  venueName,
  manualVenueCity,
  manualVenueState,
  lookupTax,
  lookupUtc,
  isKentuckyCity,
  setIsKentuckyCity,
  hasLookedUpTax,
  setHasLookedUpTax,
  kentuckyCity,
  setFormKentuckyCity,
  setKentuckyCity,
  federalEntity,
  kentuckyStateEntity,
  venueSearchReadOnly,
  setVenueSearchReadOnly,
  isBlocked,
  genericServerError,
  setIsValidManualVenueAddress,
  setManualAddress,
  updateManualCity,
  searchCountries,
}) => {
  const hasKentuckyFormErrors = useSelector(getHasKentuckyFormErrors);
  let disableNextButton = false;
  switch (venueSearchTypeRadio) {
    case BY_SEARCH:
      disableNextButton = !validSearchVenue;
      break;
    case BY_VENUE_CODE:
      disableNextButton = !validVenueCode || hasKentuckyFormErrors;
      break;
    case BY_MANUAL_ADDRESS:
      disableNextButton =
        !validManualAddress || !isKentuckyCity || !hasLookedUpTax;
      break;
    default:
      break;
  }

  return (
    show && (
      <>
        <VenueSearchTypeRadioField
          types={venueSelectInputOptions}
          name="venueSearchTypeRadio"
          validate={[required]}
          selected={venueSearchTypeRadio}
          action={(event) => {
            venueInputSelect(event);
            clearForm(setVenueSearchReadOnly);
            setFormKentuckyCity('');
          }}
        />
        {venueSearchTypeRadio === BY_SEARCH && (
          <SearchByAddress
            name="venue"
            onSelect={onSelect}
            address={address}
            venueState={venueState}
            mobile={mobile}
            isValidAddress={isValidAddress}
            clearForm={clearForm}
            hasInput={hasInput}
            isValidState={isValidState}
            isValidVenueName={isValidVenueName}
            hasRegionalTax={hasRegionalTax}
            taxRegions={taxRegions}
            isKentuckyEntity={isKentuckyEntity}
            setFormKentuckyCity={setFormKentuckyCity}
            setIsKentuckyCity={setIsKentuckyCity}
            setHasLookedUpTax={setHasLookedUpTax}
            venueSearchReadOnly={venueSearchReadOnly}
            setVenueSearchReadOnly={setVenueSearchReadOnly}
            isBlocked={isBlocked}
            genericServerError={genericServerError}
            updateManualCity={updateManualCity}
            venueName={venueName}
            searchCountries={searchCountries}
          />
        )}
        {venueSearchTypeRadio === BY_VENUE_CODE && (
          <SearchByVenueCode
            venueCodeChecked={venueCodeChecked}
            validVenueCode={validVenueCode}
            searchVenueCode={searchVenueCode}
            facilityCode={facilityCode}
            venueCode={venueCode}
            venueName={venueName}
            address={address}
            isBlocked={isBlocked}
            genericServerError={genericServerError}
            hasRegionalTax={hasRegionalTax}
            taxRegions={taxRegions}
            isKentuckyEntity={isKentuckyEntity}
            setFormKentuckyCity={setFormKentuckyCity}
          />
        )}
        {venueSearchTypeRadio === BY_MANUAL_ADDRESS && (
          <ManualVenueAddress
            usStates={usStates}
            name="manualVenue"
            manualVenueCity={manualVenueCity}
            manualVenueState={manualVenueState}
            lookupTax={lookupTax}
            hasRegionalTax={hasRegionalTax}
            taxRegions={taxRegions}
            isKentuckyEntity={isKentuckyEntity}
            lookupUtc={lookupUtc}
            isKentuckyCity={isKentuckyCity}
            setIsKentuckyCity={setIsKentuckyCity}
            setHasLookedUpTax={setHasLookedUpTax}
            setFormKentuckyCity={setFormKentuckyCity}
            setIsValidManualVenueAddress={setIsValidManualVenueAddress}
            setManualAddress={setManualAddress}
            updateManualCity={updateManualCity}
          />
        )}
        <hr />
        <div className="float-right">
          <Button
            disabled={disableNextButton}
            onClick={() => {
              scrollToPosition(basicCoverageRef);
              if (
                venueSearchTypeRadio === BY_MANUAL_ADDRESS &&
                kentuckyCity &&
                manualVenueState === 'KY'
              )
                setKentuckyCity(
                  kentuckyCity,
                  federalEntity,
                  kentuckyStateEntity,
                );
              confirm();
            }}
            text="Next"
            className="btn-primary"
          />
        </div>
      </>
    )
  );
};

Edit.propTypes = {
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  validSearchVenue: PropTypes.bool.isRequired,
  validVenueCode: PropTypes.bool.isRequired,
  validManualAddress: PropTypes.bool.isRequired,
  usStates: usStatePropType.isRequired,
  onSelect: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  venueState: PropTypes.string.isRequired,
  mobile: PropTypes.bool.isRequired,
  isValidAddress: PropTypes.func.isRequired,
  clearForm: PropTypes.func.isRequired,
  hasInput: PropTypes.bool.isRequired,
  scrollToPosition: PropTypes.func.isRequired,
  basicCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  isValidState: PropTypes.func.isRequired,
  isValidVenueName: PropTypes.func.isRequired,
  hasRegionalTax: PropTypes.bool.isRequired,
  taxRegions: PropTypes.arrayOf(venuePropType).isRequired,
  isKentuckyEntity: PropTypes.bool.isRequired,
  venueInputSelect: PropTypes.func.isRequired,
  venueSelectInputOptions: PropTypes.arrayOf(venueSearchPropType).isRequired,
  venueSearchTypeRadio: PropTypes.string.isRequired,
  searchVenueCode: PropTypes.func.isRequired,
  venueCodeChecked: PropTypes.bool.isRequired,
  facilityCode: PropTypes.string.isRequired,
  venueCode: PropTypes.string.isRequired,
  venueName: PropTypes.string.isRequired,
  manualVenueCity: PropTypes.string.isRequired,
  manualVenueState: PropTypes.string.isRequired,
  lookupTax: PropTypes.func.isRequired,
  lookupUtc: PropTypes.func.isRequired,
  isKentuckyCity: PropTypes.bool.isRequired,
  setIsKentuckyCity: PropTypes.func.isRequired,
  hasLookedUpTax: PropTypes.bool.isRequired,
  setHasLookedUpTax: PropTypes.func.isRequired,
  kentuckyCity: PropTypes.string.isRequired,
  setFormKentuckyCity: PropTypes.func.isRequired,
  setKentuckyCity: PropTypes.func.isRequired,
  federalEntity: PropTypes.string.isRequired,
  kentuckyStateEntity: PropTypes.string.isRequired,
  venueSearchReadOnly: PropTypes.bool.isRequired,
  setVenueSearchReadOnly: PropTypes.func.isRequired,
  isBlocked: PropTypes.bool.isRequired,
  genericServerError: PropTypes.bool.isRequired,
  setIsValidManualVenueAddress: PropTypes.func.isRequired,
  setManualAddress: PropTypes.func.isRequired,
  updateManualCity: PropTypes.func.isRequired,
  searchCountries: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Edit;
